'use client';

import { mergeClasses } from "@griffel/react";
import { useTableStyles_unstable } from "../Table/useTableStyles.styles.js";
export const dataGridClassNames = {
  root: 'fui-DataGrid'
};
/**
 * Apply styling to the DataGrid slots based on the state
 */
export const useDataGridStyles_unstable = state => {
  useTableStyles_unstable(state);
  // eslint-disable-next-line react-hooks/immutability
  state.root.className = mergeClasses(dataGridClassNames.root, state.root.className);
  return state;
};